import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// i18n must be imported for its side effects before App renders.
import './i18n';

// Design tokens and CSS, ordered so specificity lines up with the
// original design package.
import './styles/tokens.css';
import './styles/foundations.css';
import './styles/particles.css';
import './styles/atoms.css';
import './styles/foryou.css';
import './styles/matches.css';
import './styles/profile.css';
import './styles/cover.css';
import './styles/app.css';
import './styles/vibes-pages.css';

import { App } from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  </React.StrictMode>,
);
